import React, { useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Error from '../../components/Error/Error';
import Loading from '../../components/Loading/Loading';
import NoData from '../../components/NoData/NoData';
import ImageOnly from './Layouts/ImageOnly/ImageOnly';
import ColorSelector from './Layouts/ColorSelector/ColorSelector';
import FreeProducts from './Layouts/FreeProducts/FreeProducts';
import Default from './Layouts/Default/Default';
import NewDefault from './Layouts/NewDefault/NewDefault';
import MultipleQuantity from './Layouts/MultipleQuantity/MultipleQuantity';
import { Context as SpecialOfferContext } from '../../context/SpecialOfferContext';
import { Context as OrderContext } from '../../context/OrderContext';
import { PageView } from '../../utils/tracking';
import { buildQueryParams } from '../../utils/helpers';
import './SpecialOffer.sass';

export default function SpecialOffer(props) {
  // eslint-disable-next-line no-restricted-globals
  const queryParams = buildQueryParams(location);
  const { offer } = props;
  const history = useHistory();
  const { id: specialOfferId } = useParams();
  const currentSpecialOfferIndex = offer.specialOfferIds.indexOf(specialOfferId);

  const {
    state: { specialOffer, loading, error },
    loadSpecialOffer,
  } = useContext(SpecialOfferContext);

  const {
    state: { order },
    updateOrder,
    loadOrder,
  } = useContext(OrderContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    PageView();
    loadOrder(queryParams.internalorderid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (specialOffer.template) {
      document.querySelector('body').classList.add(specialOffer.template.name);
    }
  }, [specialOffer]);

  useEffect(() => {
    loadSpecialOffer(specialOfferId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialOfferId]);

  async function handleSubmit(product) {
    if (product) {
      const productId = product.id || product.stickyId;
      const productPrice = product.price * 1 || 0;
      const isFreeProductsTemplate = specialOffer?.template?.name === 'FreeProducts';

      let newOffer = {
        billing_model_id: product.billingModelId,
        offer_id: product.offerId,
        product_id: productId,
        productName: product.name || product.productName,
        quantity: specialOffer?.isUpgrade ? order.productQty * 1 : 1,
        position: currentSpecialOfferIndex,
        ...(product?.trial?.enabled && {
          trial: {
            ...(product.trial.productId && { product_id: product.trial.productId }),
            ...(product.trial.price && { price: product.trial.price }),
            ...(product.trial.quantity && { quantity: product.trial.quantity }),
          },
        }),
      };

      if (isFreeProductsTemplate) {
        newOffer.isFreeProduct = true;
      } else {
        newOffer.isSpecialOffer = true;
      }

      await updateOrder(order._id, {
        hasWebTv: isFreeProductsTemplate,
        orderTotal: order.orderTotal + productPrice,
        offers: [...order.offers, newOffer],
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'specialOfferPurchase',
        specialOfferIndex: currentSpecialOfferIndex,
      });
    }
    loadNextSpecialOffer();
    document.querySelector('body').classList.remove(specialOffer.template.name);
  }

  function loadNextSpecialOffer() {
    if (offer.specialOfferIds[currentSpecialOfferIndex + 1]) {
      history.push({
        pathname: `/specialoffer/${offer.specialOfferIds[currentSpecialOfferIndex + 1]}`,
        // eslint-disable-next-line no-restricted-globals
        search: location.search,
      });
    } else {
      history.push({
        pathname: '/thank-you',
        // eslint-disable-next-line no-restricted-globals
        search: location.search,
      });
    }
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error error={error} />;
  }

  if (!Object.keys(specialOffer).length) {
    return <NoData />;
  }

  let Template = Default;

  if (specialOffer.template.name === 'ColorSelector') {
    Template = ColorSelector;
  }
  if (specialOffer.template.name === 'FreeProducts') {
    Template = FreeProducts;
  }
  if (specialOffer.template.name === 'ImageOnly') {
    Template = ImageOnly;
  }
  if (specialOffer.template.name === 'MultipleQuantity') {
    Template = MultipleQuantity;
  }
  if (specialOffer.template.name === 'NewDefault' || queryParams.spotest === '1') {
    Template = NewDefault;
  }

  return (
    <Template
      offer={offer}
      order={order}
      specialOffer={specialOffer}
      onSubmit={handleSubmit}
      totalOffersCount={offer.specialOfferIds.length}
      currentSpecialOfferNumber={currentSpecialOfferIndex + 1}
    />
  );
}
